import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { DataSourceProvider } from "@/lib/data-source";
import { Toaster } from "@/ui/components/sonner";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: () => (
    <DataSourceProvider>
      <Outlet />
      <Toaster duration={4000} />
    </DataSourceProvider>
  ),
});
